import { defineStore } from 'pinia'
import router from '@/router'
import { ref, watch } from 'vue'
import { getUserInfoApi, loginApi } from '@/apis/user'
import useChatStore from './chatStore'

const useUserStore = defineStore(
  'ai-map-agent-user',
  () => {
    /**
     * 用户token
     */
    const token = ref('')

    /**
     * 用户信息
     */
    const userInfo = ref<IUserInfo | null>(null)

    /**
     * 上传oss ststoken
     */
    const uploadOssStsToken = ref<IGetUploadOssStstokenRes | null>(null)

    /**
     * 登录
     * @param data 登录请求参数
     */
    const login = async (data: IUserLoginReq) => {
      const res = await loginApi(data)
      token.value = res.data!.token
      useChatStore().loadConversationHistory()
      router.replace('/')
    }

    /**
     * 登出
     */
    const logout = () => {
      token.value = ''
      userInfo.value = null
      router.replace('/login')
      useChatStore().clearConversations()
    }

    /**
     * 获取用户信息
     */
    const getUserInfo = async () => {
      const res = await getUserInfoApi()
      userInfo.value = res.data!
    }

    watch(
      () => token.value,
      async () => {
        if (!!token.value) {
          await getUserInfo()
        }
      },
      { immediate: true },
    )

    return {
      token,
      userInfo,
      uploadOssStsToken,
      login,
      logout,
    }
  },
  {
    persist: { pick: ['token'] },
  },
)

export default useUserStore
